export default "__VITE_ASSET__68a6deb5__"